export default "__VITE_ASSET__94538fe2__"